import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {	
	getCommCodes: param => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${param.plantCd}/commonCodes?commCdType=${param.codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getBatchHistoryList: ({ searchParams, currentPage, pageUnit }) => {		
		let queryStr = '';
		//console.log('searchParams', searchParams);

		if (searchParams.pgmId !== undefined || searchParams.jobGroupId !== undefined || searchParams.searchLoginStrDt !== undefined ||searchParams.fromDate !== undefined ||searchParams.toDate !== undefined) {
			queryStr = objectToQuerystring({
				pgmId: searchParams.pgmId,
				jobGroupId: searchParams.jobGroupId,
				jobId: searchParams.jobId,
				jobNm: searchParams.jobNm,	
				fromDate: searchParams.fromDate,
				toDate: searchParams.toDate,
				useYn: searchParams.useYn,						
				currentPage,
				pageUnit
			});
		}
		//console.log('queryStr', queryStr);		
		return client
			.get(`${BASE_URL}/comm/qmsbase/batchHistory/v1/batchHistory` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}	
};
